import brands from '../data/brands.json';

export function getBrandData(brand: string, country: string) {
  return brands.find((b) => b.Brand.toLowerCase() === brand.toLowerCase() && b.Country.toLowerCase() === country.toLowerCase());
}
